module.exports = __webpack_public_path__ + "static/commutifi-fc6b26d6c6efffb80e775466103c399f.png";